import { Injectable } from '@angular/core'
import { Actions, Effect, ofType } from '@ngrx/effects'
import { HubConnectionState } from '@microsoft/signalr'
import { of } from 'rxjs/observable/of'
import { map, distinctUntilChanged, flatMap } from 'rxjs/operators'

import * as App from '../../../../store/actions/app.actions'
import * as Signal from '../actions/signalR.actions'

@Injectable()
export class SignalREffects {

  constructor(private actions$: Actions) {
  }

  // @Effect()
  // connecting$ = this.actions$.pipe(
  //   ofType(Signal.CHANGE_STATUS),
  //   map((action: Signal.ChangeStatus) => action.payload.status),
  //   distinctUntilChanged(),
  //   flatMap((status: string) => {
  //     switch (status) {
  //       case HubConnectionState.Reconnecting:
  //       case HubConnectionState.Connecting:
  //         return of(new App.ApiCallInfo({
  //           title: 'Connecting',
  //           msg: 'We are connecting you to Jean'
  //         }))
  //       case HubConnectionState.Connected:
  //         return of(new App.ApiCallSuccess({
  //           title: 'Connected!',
  //           msg: 'You are connected to Jean.'
  //         }))
  //       case HubConnectionState.Disconnected:
  //         return of(new App.ApiCallFailure({
  //           title: 'Disconnected!',
  //           msg: 'You are not connected to Jean'
  //         }))
  //       default: {
  //         return of({})
  //       }
  //     }
  //   }))
}



// WEBPACK FOOTER //
// ./src/app/shared/signalR/store/effects/signalR.effects.ts